module.exports = __webpack_public_path__ + "img/successIcon.aacf1f99.svg";